import { useReactiveVar } from '@apollo/client/react';
import usePagesAvailability from 'hooks/usePagesAvailability/usePagesAvailability';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { useLocation } from 'react-router';
import { authVar } from 'state/vars';
import SideNavUI from 'ui/organisms/SideNav/SideNav';

const SideNav: React.FC<React.PropsWithChildren> = () => {
  const { translation } = useTranslation();
  const location = useLocation();
  const { user } = useReactiveVar(authVar);
  const { getSideNavItems } = usePagesAvailability({ translation, location });

  const getItems = (currentLocation: string) =>
    getSideNavItems().map((item) => ({
      ...item,
      isSelected: `/${currentLocation.split('/')[1]}`.includes(item.location)
    }));

  return <SideNavUI items={getItems(location.pathname)} isAdmin={user?.isAdmin!} isEntraLess={user?.isEntraLess!} />;
};

export default SideNav;
